export const menuService = {
    get: _get,
    set: _set
};

import { lStorage, lStorageKeys } from '../helpers/lStorage';

const expireTime = 72*60*60*1000; //czas ważności menu 72h

function _get(menuType, lang, addr) {
	let dataExpire = lStorage.get(lStorageKeys.CATALOG_MENU_EXPIRE_PREFIX+menuType+'_'+lang+'_'+addr)
    if (!dataExpire || dataExpire<Date.now()) {
    	return null
    }
    let data = lStorage.get(lStorageKeys.CATALOG_MENU_PREFIX+menuType+'_'+lang+'_'+addr)
    if (!data){
    	return null
    }
    data = JSON.parse(data)
    return data ? data : null
}

function _set(menuType, lang, addr, data) {

    lStorage.set(lStorageKeys.CATALOG_MENU_PREFIX+menuType+'_'+lang+'_'+addr, JSON.stringify({nodes: data.nodes, tree: data.tree}));
    lStorage.set(lStorageKeys.CATALOG_MENU_EXPIRE_PREFIX+menuType+'_'+lang+'_'+addr, parseInt(Date.now())+expireTime);
}